<template>
  <div class="mainContainer">
    <div class="headerContainer">
      <div class="headerTitle">
        <component :is="$state.layout.console.left.logo"
                   v-if="$state.layout.console.left.logo" />
      </div>
      <div class="right">
        <component :is="item"
                   v-for="(item, i) in $state.layout.console.head.right"
                   :key="i"> </component>
      </div>
    </div>
    <div class="boxContainer">
      <div class="leftBox">
        <component :is="item"
                   v-for="(item, i) in $state.layout.console.left.middle"
                   :key="i"> </component>
      </div>
      <div class="rightBox">
        <div class="navigationHeader">
          <component :is="item"
                     v-for="(item, i) in $state.layout.console.navigation.items"
                     :key="i"> </component>
        </div>
        <div class="positionBox">
          <router-view v-slot="{ Component }">
            <transition name="fade-transform">
              <keep-alive :include="$state.layout.cachedViews">
                <component :is="Component" />
              </keep-alive>
            </transition>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useConsolePageLayout } from "../DefaultConsolePagePlugin"
const { $state } = useConsolePageLayout()
</script>
<style scoped lang="less">
@import "@/styles/vars.less";

.mainContainer {
  width: 100%;
  height: 100%;

  .headerContainer {
    width: 100%;
    height: 15%;
    position: absolute;
    display: flex;
    flex-direction: row;
    background: url("../assets/images/layoutHeader.png") no-repeat;
    background-size: cover;
    z-index: 10;

    .headerTitle {
      display: inline-flex;
      flex-direction: row;
      height: @head-height;
      flex: 1;
    }

    .right {
      flex: 1;
      display: inline-flex;
      justify-content: flex-end;
      margin: 20px 20px 0 0;
    }
  }

  .boxContainer {
    width: 100%;
    height: 100%;
    display: flex;
    background-color: #f6f6f6;
    align-items: flex-end;
    z-index: 10;

    .leftBox {
      margin: 15px;
      width: 15%;
      height: 88%;
      overflow: hidden;
      background-color: #ffffff;
      z-index: 200;
      display: flex;
      justify-content: center;
    }

    .rightBox {
      width: 85%;
      height: 88%;
      overflow: hidden;
      margin: 15px;
      background-color: #ffffff;
      background-color: #f6f6f6;
      z-index: 200;
      display: flex;
      flex-direction: column;

      .navigationHeader {
        width: 100%;
        height: 7%;
        background: url("../assets/images/navigationHeader.png") no-repeat;
        background-size: 100% 100%;
      }

      .positionBox {
        width: 100%;
        height: 92%;
        margin-top: 20px;
        background: #ffffff;
      }
    }
  }
}</style>
